import { Card } from 'reactstrap';
import styled from 'styled-components';
import { Colors } from '../../../constants/StyleConstants';

export const StyledCard = styled(Card)`
  border: 1px solid ${Colors.SubTextGREY};
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: 261px;
  height: 151px;
  padding: 24px;
`;

export const StyledCardImg = styled.i`
  width: 24px;
  color: ${Colors.RED};
`;

export const StyledCardTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  letter-spacing: -0.4px;
  line-height: 100%;
`;

export const StyledCardBody = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StCardText = styled.div`
  color: ${Colors.SubTextGREY};
`;

export const StIconInfo = styled.i`
  font-size: 24px;
  position: absolute;
  bottom: 20px;
`;

export const StIconArrow = styled.i`
  font-size: 24px;
  position: absolute;
  bottom: 20px;
  margin-left: -24px;
`;
